export const ANY = 'unlimited';
export const FIXED = 'fixed';
